import axios from 'axios';
import {resInt, reqInt} from "@/portal-setting-signature";

// @todo remove this
const incomePlanAxios = axios.create();
incomePlanAxios.interceptors.request.use(reqInt);
incomePlanAxios.interceptors.response.use(resInt);


//
// axios.interceptors.request.use(reqInt);
// axios.interceptors.response.use(resInt);


export {incomePlanAxios}
